<template>
  <form class="theme-form" @submit.prevent="submit">
    <Field
      label="Theme name"
      @input="$v.resource.name.$touch()"
      v-model="resource.name"
      helpText="This will be shown in the theme library"
      :error="nameError"/>

    <Field
      label="Theme slug"
      @input="$v.resource.slug.$touch()"
      v-model="resource.slug"
      helpText="This is HTML body class, it should be hyphenated and lowercase"
      :error="slugError"/>

    <btn primary>Save Changes</btn>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'ThemeForm',

  mixins: [form],

  computed: {
    ...errorMessages([
      'name',
      'slug'
    ])
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      name: {required},
      slug: {required}
    }
  }
}
</script>

<style lang="sass">
</style>
